var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BCard } from "bootstrap-vue";
import { computed, onMounted, ref } from "vue";
import { fetcher } from "@/api/schema";
import { useConfigStore } from "@/stores/configurationStore";
import { getShortToolId } from "@/utils/tool";
import { createTopicUrl, useHelpURLs } from "./helpForumUrls";
import Heading from "@/components/Common/Heading.vue";
import ExternalLink from "@/components/ExternalLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolHelpForum',
    props: {
        toolId: null,
        toolName: null
    },
    setup(__props) {
        const props = __props;
        const toolHelpTag = "tool-help";
        const helpFetcher = fetcher.path("/api/help/forum/search").method("get").create();
        const topics = ref([]);
        const posts = ref([]);
        const helpAvailable = computed(() => topics.value.length > 0);
        const root = ref(null);
        const shortToolId = computed(() => getShortToolId(props.toolId));
        const query = computed(() => `tags:${shortToolId.value}+${toolHelpTag} status:solved`);
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const response = yield helpFetcher({ query: query.value });
            const data = response.data;
            topics.value = ((_a = data.topics) !== null && _a !== void 0 ? _a : []);
            posts.value = (_b = data.posts) !== null && _b !== void 0 ? _b : [];
        }));
        const displayCount = 5;
        const displayedTopics = computed(() => topics.value.slice(0, displayCount - 1));
        const hasMore = computed(() => topics.value.length > displayCount);
        function blurbForTopic(topicId) {
            var _a;
            const firstPost = posts.value.find((post) => post.topic_id === topicId);
            return (_a = firstPost === null || firstPost === void 0 ? void 0 : firstPost.blurb) !== null && _a !== void 0 ? _a : "no content";
        }
        const { createNewTopicUrl, searchTopicUrl } = useHelpURLs({
            title: computed(() => props.toolName),
            tags: computed(() => [shortToolId.value, toolHelpTag]),
            query,
        });
        const configStore = useConfigStore();
        return { __sfc: true, props, toolHelpTag, helpFetcher, topics, posts, helpAvailable, root, shortToolId, query, displayCount, displayedTopics, hasMore, blurbForTopic, createNewTopicUrl, searchTopicUrl, configStore, FontAwesomeIcon, BButton, BCard, createTopicUrl, Heading, ExternalLink };
    }
});
